import { render, staticRenderFns } from "./LessonPreviewImage.vue?vue&type=template&id=034f4312"
import script from "./LessonPreviewImage.vue?vue&type=script&lang=js"
export * from "./LessonPreviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports